import React, { Fragment, useState, useEffect } from 'react';
import jwtDecode from 'jwt-decode';
import { useHistory, Link } from 'react-router-dom';
import {
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper, IconButton, Dialog,
    DialogActions, DialogContent, DialogContentText,
    DialogTitle, Button
} from '@mui/material';
import {
    Delete as DeleteIcon, Edit as EditIcon, ArrowForward,
    CheckCircle as ActivateIcon, Search as SearchIcon,
    Print as PrintIcon, Info as InfoIcon
} from '@mui/icons-material';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import CopyrightIcon from '@mui/icons-material/Copyright';
import RefreshIcon from '@mui/icons-material/Refresh';

function StockIn() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const history = useHistory();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [isFocused, setIsFocused] = useState(false);

    const { isAuthenticated, companyId, branchId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchtableData();
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const fetchtableData = async () => {
        setData([]);
        //const response = await fetchData('StockTransferApi', `/stockInDetails/${companyId}/${branchId}/${fromDate}/${toDate}`, token);
        fetchData('StockTransferApi', `/stockInDetails/${companyId}/${branchId}/${fromDate}/${toDate}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching StockTransfer roup Details:', error);
                if (error.response && error.response.status === 401) {
                    logout();
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            });
    };

    const handleDelete = async () => {
        deleteData('StockTransferApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchtableData();
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('StockTransferApi', `${itemId}`, token)
            .then(() => {
                fetchtableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
        return formattedDate;
    }

    const handlePrint = async (StockTransferid) => {
        // Implement print functionality
    };

    return (
        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>
            <div className='w-full mb-2 flex'>
                <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Stock Transfer In</h6>
                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '270px' : '200px',
                            height: '30px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                            marginTop: '15px',
                        }}
                    />
                </div>

                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '10px' }}>
                        From Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '10px' }}>
                        To Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <Button
                    style={{ background: 'linear-gradient(to right, #041815ff, #045157ff)', marginLeft: '8px', color: 'white', fontWeight: 'bolder', height: '30px', fontSize: '12px', textTransform: 'uppercase', marginTop: '20px', borderRadius: '25px' }}
                    onClick={fetchtableData}
                    className="linkcolor"
                >
                    Refresh
                </Button>

            </div>
            <div className="watermark">
                <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
            </div>

            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#008080' }}>
                            <TableRow>
                                <TableCell
                                    style={{
                                        background: 'linear-gradient(to right, #406b91ff, #27445D)', borderRadius: '5px', color: 'white', width: '5%',
                                        fontWeight: '600', fontSize: '12px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                    SL NO
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: 'linear-gradient(to right, #406b91ff, #27445D)', borderRadius: '5px', color: 'white', width: '10%',
                                        fontWeight: '600', fontSize: '12px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                    BILL DATE
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: 'linear-gradient(to right, #406b91ff, #27445D)', borderRadius: '5px', color: 'white', width: '10%',
                                        fontWeight: '600', fontSize: '12px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                    BILL NUMBER
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: 'linear-gradient(to right, #406b91ff, #27445D)', borderRadius: '5px', color: 'white', width: '35%',
                                        fontWeight: '600', fontSize: '12px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                    FROM BRANCH NAME
                                </TableCell>
                                <TableCell style={{
                                    background: 'linear-gradient(to right, #406b91ff, #27445D)', borderRadius: '5px', color: 'white', width: '10%',
                                    fontWeight: '600', fontSize: '12px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                                }}>
                                    AMOUNT
                                </TableCell>
                                <TableCell style={{
                                    background: 'linear-gradient(to right, #406b91ff, #27445D)', borderRadius: '5px', color: 'white', width: '10%',
                                    fontWeight: '600', fontSize: '12px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                                }}>
                                    QUANTITY
                                </TableCell>
                                <TableCell style={{
                                    background: 'linear-gradient(to right, #406b91ff, #27445D)', borderRadius: '5px', color: 'white', width: '7%',
                                    fontWeight: '600', fontSize: '12px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                                }}>

                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ backgroundColor: '#C3E9E4' }}>
                            {filteredData.map((item, index) => (
                                // <TableRow
                                //     key={item.id}
                                //     className={item.IsActive ? '' : 'inactiveRow'}
                                //     style={{ backgroundColor: item.InputAccepted ? '#d4edda' : item.InputRejected ? '#f8d7da' : '#D9C9F7' }}

                                // >
                                <TableRow
                                    key={item.id}
                                    className={item.IsActive ? '' : 'inactiveRow'}
                                    style={{
                                        backgroundColor: item.IsActive
                                            ? item.InputAccepted
                                                ? '#d4edda'
                                                : item.InputRejected
                                                    ? '#f8d7da'
                                                    : '#D9C9F7'
                                            : '#f5f5f5', // Set the color for inactive rows
                                    }}
                                >

                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '1px', width: '3%' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '1px', width: '10%' }}>{formatDate(item.BillDate)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '1px', width: '10%' }}>{item.BillPrefix}/S/{item.BillNumber}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '1px', width: '30%' }}>{item.ToBranchName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '1px', width: '15%', textAlign: 'right' }}>{item.GrandTotal !== undefined && item.GrandTotal !== null ? item.GrandTotal.toFixed(2) : "0.00"}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '1px', width: '15%', textAlign: 'right' }}>{item.TotalQuantity}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '20%', textAlign: 'right' }}>
                                        {/* Rejected - Approved */}
                                        {item.IsActive ? (
                                            item.InputRejected ? (
                                                <>
                                                    <IconButton component={Link} to={`/StockInDetail/${item.Id}`}>
                                                        <InfoIcon style={{ color: 'brown' }} />
                                                    </IconButton>
                                                    <span style={{ color: 'red', marginLeft: '19px', fontWeight: 'bolder' }}>Rejected</span>
                                                </>
                                            ) : item.InputAccepted ? (
                                                <>
                                                    <IconButton component={Link} to={`/StockInDetail/${item.Id}`}>
                                                        <InfoIcon style={{ color: 'darkgoldenrod' }} />
                                                    </IconButton>
                                                    <span style={{ color: 'green', marginLeft: '19px', fontWeight: 'bolder' }}>Approved</span>
                                                </>
                                            ) : (
                                                <>
                                                    <IconButton component={Link} to={`/StockInDetail/${item.Id}`}>
                                                        <InfoIcon style={{ color: 'black' }} />
                                                    </IconButton>
                                                    <span style={{ color: 'black', marginLeft: '19px', fontWeight: 'bolder' }}>Waiting For Approval</span>
                                                </>
                                            )
                                        ) : (
                                            <>
                                                <IconButton component={Link} to={`/StockInDetail/${item.Id}`}>
                                                    <InfoIcon style={{ color: 'gray' }} />
                                                </IconButton>
                                                <span style={{ color: 'gray', marginLeft: '20px', fontWeight: 'bolder' }}>Inactive</span>
                                            </>
                                        )}

                                    </TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>

                    </Table>
                </TableContainer>
            </div>
        </div>
    );
}

export default StockIn;
